import { shallowEqual, useSelector } from 'react-redux';
import { DataStatus } from 'src/core/engine';

import { items_qty_selector, status_selector } from '../utils/selectors';

export function useItemCount() {
    const status = useSelector(status_selector, shallowEqual);
    const count = useSelector(items_qty_selector, shallowEqual);
    const pending = status === DataStatus.Pending || status === DataStatus.Idle;
    return { status, pending, count };
}
